import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
    selector: '[appDisableMultipleClick]',
    standalone: false
})
export class DisableMultipleClickDirective {

  constructor(private readonly elementRef: ElementRef) { }

  @HostListener('click', ['$event'])
  click(_event: MouseEvent) {
    this.elementRef.nativeElement.setAttribute('disabled', true);
    setTimeout(() => {
      this.elementRef.nativeElement.removeAttribute('disabled');
    }, 1000);
  }
}
